import { render } from "./FormCheckBoxSubFormFieldComponent.vue?vue&type=template&id=c4c6d952"
import script from "./FormCheckBoxSubFormFieldComponent.vue?vue&type=script&lang=js"
export * from "./FormCheckBoxSubFormFieldComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__